import React from 'react';
import { Link } from 'react-router-dom';
import PublicSEO from '../../components/public/PublicSEO';
import { publicPath } from '../../utils/canonicalUrl';
import { buildBreadcrumb } from '../../utils/jsonLd';
import './ContentGuide.css';

export default function FondiSanitariPage() {
  return (
    <div className="vc-guide">
      <PublicSEO
        title="Fondi e assicurazioni"
        description="Fondi sanitari e polizze su Virtual Clinic: in arrivo i prezzi convenzionati per compagnia. Oggi puoi confrontare orari e prezzi privati."
        canonicalPath="/fondi-sanitari"
        jsonLd={[
          buildBreadcrumb([
            { name: 'Home', path: '/' },
            { name: 'Fondi e assicurazioni' },
          ]),
        ]}
      />
      <div className="vc-guide__inner">
        <h1>Fondi e assicurazioni</h1>
        <p className="vc-guide__lead">
          Fondi sanitari e polizze assicurative verranno trattati allo stesso modo in ricerca:
          scegli la compagnia e vedi il prezzo del relativo tariffario prima di prenotare.
        </p>

        <section>
          <h2>Stato attuale</h2>
          <p>
            Il filtro in ricerca è in standby: ogni fondo o assicurazione ha un tariffario proprio
            e non è ancora collegato. Intanto puoi cercare e prenotare con prezzo privato.
          </p>
        </section>

        <section>
          <h2>Cosa arriverà</h2>
          <ol>
            <li>In ricerca indichi se paghi privatamente oppure con fondo/assicurazione.</li>
            <li>Selezioni la compagnia dall&apos;elenco disponibile.</li>
            <li>Nei risultati compare il prezzo della tariffa collegata, prima di confermare.</li>
          </ol>
        </section>

        <section>
          <h2>Presa in carico (PIC)</h2>
          <p>
            Quando i tariffari saranno attivi, se la struttura gestisce la pratica fondo lo stato della PIC
            sarà seguito dall&apos;hub struttura (documenti, approvazione, eventuale rifiuto).
          </p>
        </section>

        <section>
          <h2>SSN</h2>
          <p>
            Virtual Clinic non sostituisce il CUP regionale per le prestazioni SSN accreditate.
            L&apos;opzione SSN in ricerca resta informativa: per quelle prestazioni segui i canali della tua ASL.
          </p>
          <div className="vc-guide__cta-row">
            <Link to={publicPath('/ricerca')} className="vc-guide__cta">
              Cerca disponibilità
            </Link>
            <Link to={publicPath('/come-funziona')} className="vc-guide__cta vc-guide__cta--secondary">
              Come funziona la prenotazione
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
}
